import styled from 'styled-components';
import { Loader } from '../lib/components';

interface CarouselLoaderProps {
  spinnerColor?: string;
  className?: string;
}

export function CarouselLoader({
  spinnerColor,
  className
}: CarouselLoaderProps) {
  return (
    <StyledLoader className={className}>
      <Loader color={spinnerColor} />
    </StyledLoader>
  );
}

const StyledLoader = styled.div`
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
